import { RESET_FILTERS, UPDATE_FILTERS } from '../actions'
import { HYDRATE_STATE } from '../../../integrations/hydration'

/**
 * @typedef {Object} SearchFiltersState Filters state of the search app
 *
 * @property {string} q Custom query string
 * @property {[number, number]} distance Distance range filter
 * @property {[number, number]} ascent Ascent range filter
 * @property {number[]} categories Categories filter
 * @property {number[]} surfaces Surface types filter
 * @property {boolean} onlyLoop Only loop routes filter
 */

/**
 * @param {SearchFiltersState} initialState
 * @returns {(state: SearchFiltersState, action: Object) => SearchFiltersState}
 */
export default function filtersReducer(initialState) {
    return (state = initialState, action) => {
        switch (action.type) {
            case UPDATE_FILTERS:
                return action.filters

            case RESET_FILTERS:
                return initialState

            case HYDRATE_STATE:
                return action.state.filters ? {
                    ...state,
                    ...action.state.filters,
                } : state

            default:
                return state
        }
    }
}
